export function formatPriceCurrency(
    price: number | string,
    currency: "USD" | "EUR" | "CZK",
) {
    if (currency === "USD") {
        return `$${price}`;
    }
    if (currency === "EUR") {
        return `${price} €`;
    }
    if (currency === "CZK") {
        return `${price} Kč`;
    }

    throw new Error("Unknown currency");
}
